import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import { stepBarList } from './constant';

export default function StepBar({steps, state}) {

  const stepsToDisplay = steps.filter((step) => step.conditionToShow(state));

  return (
    <div className="step-bar">
      {stepsToDisplay.map((step, i) => (
        <div className='step-bar-container' key={i}>
        <div key={i} className='step-details' >
          <Image src={step.icon} alt={step.title} />
          <span>{step.title}</span>
        </div>
        {i < stepsToDisplay.length - 1 && (
          <Image src={require('./icons/arrow.svg')} alt="arrow" />
        )}
        </div>
        
      ))}
    </div>
  );
}